export default __webpack_public_path__ + "static/media/Gui-Monteiro.4a3efba8.jpg";